import React, { useState } from 'react';
import {
  FormControl, Button, Typography, Grid,
  FormLabel, TextField, Select, MenuItem
} from '@mui/material';
import ImageUpload from '../components/ImageUpload/ImageUpload';
import style from './Payment.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { cartAction, updatePayment, driveImageUpload, getPaidList } from '../features/cartAction';
import { userProfile } from '../features/auth/authAction';
import { useParams, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { resetCart } from '../features/cartSlice';
import { resetUserDetails } from '../features/userDetailsSlice';
import Alert from '@mui/material/Alert';

const PaymentPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const storedBankSlip = useSelector((state) => state.cartDetails.data)
  const uploadResponse = useSelector((state) => state.cartDetails?.bankData)
  const permission = useSelector(state => state.auth?.permission?.user_permission);
  const paidUserList = useSelector((state) => state.cartDetails?.paidUserList?.data);
  const bankDataLoading = useSelector((state) => state.cartDetails.bankDataLoading)
  const profileInfo = useSelector((state) => state.auth?.profileInfo);
  const userToken = useSelector((state) => state.auth?.userToken);

  // Fetch profile if missing
  React.useEffect(() => {
    if (!profileInfo && userToken) {
      dispatch(userProfile());
    }
  }, [profileInfo, userToken, dispatch]);

  React.useEffect(() => {
    if (params.loggedUId) {
      dispatch(getPaidList(params.loggedUId));
    }
  }, [params.loggedUId, dispatch]);

  React.useEffect(() => {
    const message = uploadResponse?.message || uploadResponse; // Handle both object and string cases safely
    if (message === 'Bank slip uploaded Successfully' ||
      message === 'Already payment has done!!!' ||
      message === 'Bank slip update Successfully') {
      dispatch(resetCart());
      dispatch(resetUserDetails());
      // Show success message then navigate back
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    }
  }, [uploadResponse, navigate, dispatch]);

  console.log('permission', permission);
  React.useEffect(() => {
    if (permission && permission != 0) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        navigate(-1);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [permission, navigate])

  React.useEffect(() => {
    if (profileInfo?.user) {
      setFormData(prev => ({
        ...prev,
        user_name: profileInfo.user.name || prev.user_name,
        email: profileInfo.user.email || prev.email,
        // Only fetch package_type from paidUserList if available, otherwise keep empty or prev
        package_type: (paidUserList && paidUserList.length > 0 ? paidUserList[0].package_type : '') || prev.package_type,
      }));
    } else if (paidUserList && paidUserList?.length > 0) {
      // Fallback to paidUserList if profileInfo is not yet loaded (though profileInfo should load first for auth users)
      setFormData((prev) => ({
        ...prev,
        user_name: paidUserList[0].user_name || prev.user_name,
        email: paidUserList[0].email || prev.email,
        package_type: paidUserList[0].package_type || prev.package_type,
      }));
    }
  }, [paidUserList, profileInfo]);

  const [showAlert, setShowAlert] = useState(false);
  const [formData, setFormData] = useState({
    user_name: '',
    email: '',
    currentDate: '',
    package_type: '',
    user_id: ''
  });
  const [finalData, setFinalData] = useState({});

  const handlePayment = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  React.useEffect(() => {
    if (params.loggedUId) {
      setFormData(prev => ({
        ...prev,
        user_id: params.loggedUId
      }));
    }
  }, [params.loggedUId]);

  React.useEffect(() => {
    setFinalData({
      ...formData,
      ...storedBankSlip,
    });
  }, [formData, storedBankSlip]);
  const bankDetailsSubmit = () => {
    // If there is a bank slip file selected, upload it
    if (storedBankSlip && storedBankSlip.file) {
      let imgFormData = new FormData();
      imgFormData.append("slip_name", storedBankSlip.file);
      imgFormData.append("user_id", params.loggedUId);
      imgFormData.append("isBankSlip", "true");
      imgFormData.append("isProfileImage", "false");
      dispatch(driveImageUpload(imgFormData));
    }

    dispatch(cartAction(finalData));
    setFormData({
      user_name: '',
      email: '',
      package_type: '',
      user_id: params.loggedUId
    });
  }
  const updateBankDetailsSubmit = () => {
    // If there is a bank slip file selected, upload it
    if (storedBankSlip && storedBankSlip.file) {
      let imgFormData = new FormData();
      imgFormData.append("slip_name", storedBankSlip.file);
      imgFormData.append("user_id", params.loggedUId);
      imgFormData.append("isBankSlip", "true");
      imgFormData.append("isProfileImage", "false");
      dispatch(driveImageUpload(imgFormData));
    }

    dispatch(updatePayment(finalData));
    setFormData({
      user_name: '',
      email: '',
      package_type: '',
      user_id: params.loggedUId
    });
  }

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 720,
      maxHeight: 600,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #C3937C',
      margin: '1rem'
    },
  }));
  return (
    <>
      {showAlert && (
        <Alert
          variant="filled"
          severity="warning"
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}
        >
          You Already completed your payment for update it Contact +9475-7734313 | +9477-8113048. Thank you for your purchase!
        </Alert>
      )}

      {!showAlert && (
        bankDataLoading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'text.primary' }}>
            <CircularProgress size="3rem" />
          </Box>
        )
          : (
            <FormControl className={style.paymentPage}>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit">බැංකු තොරතුරු</Typography>
                    <br />
                    <em>{'WhatsApp: '}</em> <b>{'+9475 7734313, +9477 8113048'}</b> <br /><br />
                    <em>{'Name: '}</em> <b>{'r.m.r.s.c.kumara'}</b> <br />
                    <em>{'Branch: '}</em> <b>{'Sri Jayawardanapura Branch'}</b> <br />
                    <em>{'Account Number: '}</em> <b>{'78429238'}</b>
                  </React.Fragment>
                }
              >
                <Alert severity="info" sx={{ m: '2rem' }}>
                  <Typography component="span" sx={{ color: 'red' }}>
                    විස්තර ලබා ගැනීමට මෙය යොමු කරන්න,<br />
                    Account Number 78429238, Name: r.m.r.s.c.kumara, Branch: Sri Jayawardanapura Branch<br />
                  </Typography>
                  {" "}ඔබට ගෙවීම් පත්‍රිකාව පහත උඩුගත කිරීමට හෝ බැංකු හුවමාරුව සිදු කළ හැක. WhatsApp හි සම්බන්ධතා අංකය
                </Alert>
              </HtmlTooltip>
              <form className={style.form} encType="multipart/form-data">
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <FormLabel htmlFor="user_name">සම්පූර්ණ නම</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      id="user_name"
                      name="user_name"
                      label="සම්පූර්ණ නම"
                      variant="outlined"
                      value={formData.user_name}
                      onChange={handlePayment}
                      fullWidth
                      required

                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormLabel htmlFor="email">විද්යුත් තැපෑල</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      id="email"
                      name="email"
                      label="විද්යුත් තැපෑල"
                      variant="outlined"
                      value={formData.email}
                      onChange={handlePayment}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormLabel id="package-label">පැකේජ වර්ගය</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Select
                      labelId="package-label"
                      id="package_type"
                      name="package_type"
                      value={formData.package_type}
                      onChange={handlePayment}
                      fullWidth
                      required
                      displayEmpty
                    >
                      <MenuItem value=""><em>අ තේරීමක් නැත</em></MenuItem>
                      <MenuItem value='1-Month'>1 මසකට</MenuItem>
                      <MenuItem value='3-Month'>3 දෙමසකට</MenuItem>
                      <MenuItem value='6-Month'>6 මසකට</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12}>
                    <ImageUpload imageType="bankSlip" />
                  </Grid>
                  {paidUserList?.length > 0 ?
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={updateBankDetailsSubmit}
                        fullWidth
                        sx={{ borderRadius: 999, py: 1.1 }}
                      >
                        යාවත්කාලීන කරන්න
                      </Button>
                    </Grid> :
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={bankDetailsSubmit}
                        fullWidth
                        sx={{ borderRadius: 999, py: 1.1 }}
                      >
                        උඩුගත කරන්න
                      </Button>
                    </Grid>
                  }

                </Grid>
              </form>
            </FormControl>
          )
      )}


    </>
  )
}

export default PaymentPage;   